//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";
export const UNREAD_MAIL = "/unread/mail";
export const STARED_MAIL = "/stared/mail";
export const LABEL_MAIL = "/label/mail";
export const TRASH_MAIL = "/trash/mail";

// Ecommerce
// Product
export const GET_PRODUCTS = "/product";
export const DELETE_PRODUCT = "/delete/product";
export const ADD_NEW_PRODUCT = "/add/product";
export const UPDATE_PRODUCT = "/update/product";

// Orders
export const GET_ORDERS = "/order";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

// Customers
export const GET_CUSTOMERS = "/apps/customer";
export const ADD_NEW_CUSTOMER = "/apps/customer";
export const UPDATE_CUSTOMER = "/apps/customer";
export const DELETE_CUSTOMER = "/apps/customer";

// Sellers
export const GET_SELLERS = "/sellers";

// Project list
export const GET_PROJECT_LIST = "/project/list";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";

// CRM
// Conatct
export const GET_CONTACTS = "/apps/contact";
export const ADD_NEW_CONTACT = "/apps/contact";
export const UPDATE_CONTACT = "/apps/contact";
export const DELETE_CONTACT = "/apps/contact";

// Companies
export const GET_COMPANIES = "/apps/company";
export const ADD_NEW_COMPANIES = "/apps/company";
export const UPDATE_COMPANIES = "/apps/company";
export const DELETE_COMPANIES = "/apps/company";

// Lead
export const GET_LEADS = "/apps/lead";
export const ADD_NEW_LEAD = "/apps/lead";
export const UPDATE_LEAD = "/apps/lead";
export const DELETE_LEAD = "/apps/lead";

// Deals
export const GET_DEALS = "/deals";

// Crypto
export const GET_TRANSACTION_LIST = "/transaction-list";
export const GET_ORDRER_LIST = "/order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";

// TicketsList
export const GET_TICKETS_LIST = "/ticket";
export const ADD_NEW_TICKET = "/add/ticket";
export const UPDATE_TICKET = "/update/ticket";
export const DELETE_TICKET = "/delete/ticket";

// Dashboard Analytics

// Sessions by Countries
export const GET_ALL_DATA = "/all-data";
export const GET_HALFYEARLY_DATA = "/halfyearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

// Audiences Metrics
export const GET_ALLAUDIENCESMETRICS_DATA = "/allAudiencesMetrics-data";
export const GET_MONTHLYAUDIENCESMETRICS_DATA = "/monthlyAudiencesMetrics-data";
export const GET_HALFYEARLYAUDIENCESMETRICS_DATA =
  "/halfyearlyAudiencesMetrics-data";
export const GET_YEARLYAUDIENCESMETRICS_DATA = "/yearlyAudiencesMetrics-data";

// Users by Device
export const GET_TODAYDEVICE_DATA = "/todayDevice-data";
export const GET_LASTWEEKDEVICE_DATA = "/lastWeekDevice-data";
export const GET_LASTMONTHDEVICE_DATA = "/lastMonthDevice-data";
export const GET_CURRENTYEARDEVICE_DATA = "/currentYearDevice-data";

// Audiences Sessions by Country
export const GET_TODAYSESSION_DATA = "/todaySession-data";
export const GET_LASTWEEKSESSION_DATA = "/lastWeekSession-data";
export const GET_LASTMONTHSESSION_DATA = "/lastMonthSession-data";
export const GET_CURRENTYEARSESSION_DATA = "/currentYearSession-data";

// Dashboard CRM

// Balance Overview
export const GET_TODAYBALANCE_DATA = "/todayBalance-data";
export const GET_LASTWEEKBALANCE_DATA = "/lastWeekBalance-data";
export const GET_LASTMONTHBALANCE_DATA = "/lastMonthBalance-data";
export const GET_CURRENTYEARBALANCE_DATA = "/currentYearBalance-data";

// Deal type
export const GET_TODAYDEAL_DATA = "/todayDeal-data";
export const GET_WEEKLYDEAL_DATA = "/weeklyDeal-data";
export const GET_MONTHLYDEAL_DATA = "/monthlyDeal-data";
export const GET_YEARLYDEAL_DATA = "/yearlyDeal-data";

// Sales Forecast

export const GET_OCTSALES_DATA = "/octSales-data";
export const GET_NOVSALES_DATA = "/novSales-data";
export const GET_DECSALES_DATA = "/decSales-data";
export const GET_JANSALES_DATA = "/janSales-data";

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = "/allRevenue-data";
export const GET_MONTHREVENUE_DATA = "/monthRevenue-data";
export const GET_HALFYEARREVENUE_DATA = "/halfYearRevenue-data";
export const GET_YEARREVENUE_DATA = "/yearRevenue-data";

// Dashboard Crypto
// Portfolio
export const GET_BTCPORTFOLIO_DATA = "/btcPortfolio-data";
export const GET_USDPORTFOLIO_DATA = "/usdPortfolio-data";
export const GET_EUROPORTFOLIO_DATA = "/euroPortfolio-data";

// Market Graph
export const GET_ALLMARKETDATA_DATA = "/allMarket-data";
export const GET_YEARMARKET_DATA = "/yearMarket-data";
export const GET_MONTHMARKET_DATA = "/monthMarket-data";
export const GET_WEEKMARKET_DATA = "/weekMarket-data";
export const GET_HOURMARKET_DATA = "/hourMarket-data";

// Dashboard Crypto
// Project Overview
export const GET_ALLPROJECT_DATA = "/allProject-data";
export const GET_MONTHPROJECT_DATA = "/monthProject-data";
export const GET_HALFYEARPROJECT_DATA = "/halfYearProject-data";
export const GET_YEARPROJECT_DATA = "/yearProject-data";

// Project Status
export const GET_ALLPROJECTSTATUS_DATA = "/allProjectStatus-data";
export const GET_WEEKPROJECTSTATUS_DATA = "/weekProjectStatus-data";
export const GET_MONTHPROJECTSTATUS_DATA = "/monthProjectStatus-data";
export const GET_QUARTERPROJECTSTATUS_DATA = "/quarterProjectStatus-data";

// Dashboard NFT
// Marketplace
export const GET_ALLMARKETPLACE_DATA = "/allMarketplace-data";
export const GET_MONTHMARKETPLACE_DATA = "/monthMarketplace-data";
export const GET_HALFYEARMARKETPLACE_DATA = "/halfYearMarketplace-data";
export const GET_YEARMARKETPLACE_DATA = "/yearMarketplace-data";

// Project
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Pages > Team
export const GET_TEAMDATA = "/teamData";
export const DELETE_TEAMDATA = "/delete/teamData";
export const ADD_NEW_TEAMDATA = "/add/teamData";
export const UPDATE_TEAMDATA = "/update/teamData";

// File Manager
// Folder
export const GET_FOLDERS = "/folder";
export const DELETE_FOLDER = "/delete/folder";
export const ADD_NEW_FOLDER = "/add/folder";
export const UPDATE_FOLDER = "/update/folder";

// File
export const GET_FILES = "/file";
export const DELETE_FILE = "/delete/file";
export const ADD_NEW_FILE = "/add/file";
export const UPDATE_FILE = "/update/file";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

// To do Project
export const GET_PROJECTS = "/projects";
export const ADD_NEW_TODO_PROJECT = "/add/project";

//JOB APPLICATION
export const GET_APPLICATION_LIST = "/application-list";
export const ADD_NEW_APPLICATION_LIST = "/add/application-list";
export const UPDATE_APPLICATION_LIST = "/update/application-list";
export const DELETE_APPLICATION_LIST = "/delete/application-list";

//JOB APPLICATION
export const GET_API_KEY = "/api-key";

// CANDIDATE LIST
export const GET_CANDIDATE = "/candidates";
export const ADD_NEW_CANDIDATE = "add/candidates";
export const UPDATE_CANDIDATE = "update/candidates";
export const DELETE_CANDIDATE = "delete/candidates";

export const GET_CANDIDATE_GRID = "/category-grid";
export const ADD_CANDIDATE_GRID = "/add/category-grid";

export const GET_CATEGORY_LIST = "/category-list";
export const ADD_CATEGORY_LIST = "/add/category-list";

/* INTEGRASI */
//Admin Account
export const LOGIN = "/admin/account/login";
export const GET_TOKEN = "/admin/account/check_token";
export const ADMIN_CHANGE_PASSWORD = "/admin/account/change_password";
export const ADMIN_CHANGE_PASSWORD_FIRST_LOGIN =
  "/admin/account/change_password_first_login";

//Admin Combo
export const ADMIN_GET_COMBO_MEMBER = "/admin/combo/member";
export const ADMIN_GET_COMBO_SHIFT = "/admin/combo/shift";
export const ADMIN_GET_COMBO_PATROL = "/admin/combo/patrol_location";
export const ADMIN_GET_COMBO_SALARY = "/admin/combo/salary";
export const ADMIN_GET_COMBO_INSURANCE = "/admin/combo/insurance";
export const ADMIN_GET_COMBO_BENEFIT = "/admin/combo/benefit";
export const ADMIN_GET_COMBO_DEDUCTION = "/admin/combo/deduction";

//Admin Admin Account
export const ADMIN_GET_ALL_ADMINS = "/admin/admin";
export const ADMIN_CREATE_ADMIN = "/admin/admin";
export const ADMIN_GET_ADMIN_BY_ID = "/admin/admin/{id}";
export const ADMIN_UPDATE_ADMIN = "/admin/admin/{id}";
export const ADMIN_DELETE_ADMIN_BY_ID = "/admin/admin/{id}";
export const ADMIN_GET_ADMIN_EXCEL = "/admin/admin_excel";

//Admin Member Account
export const ADMIN_GET_ALL_MEMBERS = "/admin/member";
export const ADMIN_CREATE_MEMBER = "/admin/member";
export const ADMIN_GET_MEMBER_BY_ID = "/admin/member/{id}";
export const ADMIN_UPDATE_MEMBER = "/admin/member/{id}";
export const ADMIN_DELETE_MEMBER_BY_ID = "/admin/member/{id}";
export const ADMIN_RESET_MEMBER_PASSWORD = "/admin/member/{id}/reset_password";
export const ADMIN_GET_ALL_MEMBERS_EXCEL = "/admin/member_excel";
export const ADMIN_COMBO_WORK_LOCATION = "/admin/member/combo/work_location";
export const ADMIN_COUNT_ALL_MEMBER = "/admin/member/count/all";
export const ADMIN_UPLOAD_MEMBER = "/admin/member/upload";
export const ADMIN_UPLOAD_PROFILE_PICTURES =
  "/admin/member/upload_profile_pictures";

//Admin Manage Work Location
export const ADMIN_GET_ALL_WORK_LOCATION = "/admin/work_location";
export const ADMIN_CREATE_WORK_LOCATION = "/admin/work_location";
export const ADMIN_GET_WORK_LOCATION_BY_ID = "/admin/work_location/{id}";
export const ADMIN_UPDATE_WORK_LOCATION = "/admin/work_location/{id}";
export const ADMIN_DELETE_WORK_LOCATION_BY_ID = "/admin/work_location/{id}";

//Admin Manage Shift
export const ADMIN_GET_ALL_SHIFT = "/admin/shift";
export const ADMIN_CREATE_SHIFT = "/admin/shift";
export const ADMIN_UPDATE_SHIFT = "/admin/shift/{id}";
export const ADMIN_UPDATE_STATUS_SHIFT = "/admin/shift/change_active/{id}";
export const ADMIN_GET_SHIFT_BY_ID = "/admin/shift/{id}";
export const ADMIN_DELETE_SHIFT_BY_ID = "/admin/shift/{id}";
export const ADMIN_GENERATE_CHECKOUT_QR_CODE =
  "/admin/shift/generate_checkout_qr_code/{id}";

//Admin Manage Overtime
export const ADMIN_GET_ALL_OVERTIME = "/admin/overtime";

//Admin Manage Patrol
export const ADMIN_GET_ALL_PATROL = "/admin/patrol";
export const ADMIN_GET_ALL_PATROL_EXCEL = "/admin/patrol/excel";

//Admin Manage Patrol Location
export const ADMIN_GET_ALL_PATROL_LOCATION = "/admin/patrol_location";
export const ADMIN_CREATE_PATROLL_LOCATION = "/admin/patrol_location";
export const ADMIN_GET_PATROL_LOCATION_BY_ID = "/admin/patrol_location/{id}";
export const ADMIN_UPDATE_PATROL_LOCATION = "/admin/patrol_location/{id}";
export const ADMIN_DELETE_PATROL_LOCATION_BY_ID = "/admin/patrol_location/{id}";

//Admin Manage Notification
export const ADMIN_GET_ALL_NOTIF = "/admin/notification";

//Admin Manage Attendance
export const ADMIN_GET_ALL_ATTENDANCE = "/admin/attendance";
export const ADMIN_GET_ALL_ATTENDANCE_EXCEL = "/admin/attendance/excel";

//Admin Manage Event
export const ADMIN_GET_ALL_EVENTS = "/admin/event";
export const ADMIN_CREATE_EVENT = "/admin/event";
export const ADMIN_GET_EVENT_BY_ID = "/admin/event/";
export const ADMIN_UPDATE_EVENT = "/admin/event/{id}";
export const ADMIN_DELETE_EVENT_BY_ID = "/admin/event/{id}";
export const ADMIN_GET_EVENT_ATTENDANCE = "/admin/event/{id}/attendances";
export const ADMIN_GET_EVENT_ATTENDANCE_EXCEL =
  "/admin/event/{id}/attendances/excel";

//Admin Manage Attendance By Photo
export const ADMIN_GET_ALL_ATTENDANCE_BY_PHOTO = "/admin/attendance_by_photo";
export const ADMIN_GET_ALL_ATTENDANCE_BY_PHOTO_EXCEL =
  "/admin/attendance_by_photo/excel";

//Admin Manage Menu
export const ADMIN_GET_ADMIN_MENUS = "/admin/menu/admin";
export const ADMIN_GET_COMBO_MEMBER_MENUS = "/admin/menu/member/combo_menus";
export const ADMIN_GET_MEMBER_MENUS = "/admin/menu/member";
export const ADMIN_UPDATE_MEMBER_MENUS = "/admin/menu/member";

//Admin Manage Company
export const ADMIN_GET_COMPANY_DETAIL = "/admin/company";
export const ADMIN_UPDATE_COMPANY = "/admin/company";
export const ADMIN_GET_COMPANY_SETTING_BY_ID = "/admin/company/setting";

//Admin Work Extension
export const ADMIN_GET_ALL_WORK_EXTENSION = "/admin/work_extension";
export const ADMIN_GET_ALL_WORK_EXTENSIONS_EXCEL =
  "/admin/work_extension/excel";
export const ADMIN_UPDATE_WORK_EXTENSION_STATUS =
  "/admin/work_extension/{idWorkExtension}/update_status";

//Admin News
export const ADMIN_GET_LIST_NEWS = "/admin/news";
export const ADMIN_ADD_NEWS = "/admin/news";
export const ADMIN_GET_NEWS_BY_ID = "/admin/news/{id}";
export const ADMIN_UPDATE_NEWS_BY_ID = "/admin/news/{id}";
export const ADMIN_DELETE_NEWS_BY_ID = "/admin/news/{id}";

//Admin Payslip
export const ADMIN_GET_ALL_PAYSLIP = "/admin/payslip";
export const ADMIN_CREATE_PAYSLIP = "/admin/payslip";
export const ADMIN_GET_PAYSLIP_BY_ID = "/admin/payslip/{id}";
export const ADMIN_UPDATE_PAYSLIP_BY_ID = "/admin/payslip/{id}";
export const ADMIN_DELETE_PAYSLIP_BY_ID = "/admin/payslip/{id}";
export const ADMIN_DOWNLOAD_PDF_BY_ID = "/admin/payslip/download_pdf/{id}";
export const ADMIN_DOWNLOAD_PAYSLIP_EXCEL = "/admin/payslip/download_excel";
export const ADMIN_DOWNLOAD_PAYSLIP_ZIP = "/admin/payslip/download_pdf_zip";
export const ADMIN_UPLOAD_PAYSLIP = "/admin/payslip/import";
export const ADMIN_DOWNLOAD_PAYSLIP_TEMPLATE_EXCEL = "/admin/payslip/download_template";
export const ADMIN_BULK_PUBLISH_PAYSLIP = "/admin/payslip/publish/bulk";

//Admin Manage Salary
export const ADMIN_GET_ALL_SALARY = "/admin/salary";
export const ADMIN_CREATE_SALARY = "/admin/salary";
export const ADMIN_GET_SALARY_BY_ID = "/admin/salary/{id}";
export const ADMIN_UPDATE_SALARY_BY_ID = "/admin/salary/{id}";
export const ADMIN_DELETE_SALARY_BY_ID = "/admin/salary/{id}";

//Admin Manage Insurance
export const ADMIN_GET_ALL_INSURANCE = "/admin/insurance";
export const ADMIN_CREATE_INSURANCE = "/admin/insurance";
export const ADMIN_GET_INSURANCE_BY_ID = "/admin/insurance/{id}";
export const ADMIN_UPDATE_INSURANCE_BY_ID = "/admin/insurance/{id}";
export const ADMIN_DELETE_INSURANCE_BY_ID = "/admin/insurance/{id}";

//Admin Manage Benefit
export const ADMIN_GET_ALL_BENEFIT = "/admin/benefit";
export const ADMIN_CREATE_BENEFIT = "/admin/benefit";
export const ADMIN_GET_BENEFIT_BY_ID = "/admin/benefit/{id}";
export const ADMIN_UPDATE_BENEFIT_BY_ID = "/admin/benefit/{id}";
export const ADMIN_DELETE_BENEFIT_BY_ID = "/admin/benefit/{id}";

//Admin Manage Deduction
export const ADMIN_GET_ALL_DEDUCTION = "/admin/deduction";
export const ADMIN_CREATE_DEDUCTION = "/admin/deduction";
export const ADMIN_GET_DEDUCTION_BY_ID = "/admin/deduction/{id}";
export const ADMIN_UPDATE_DEDUCTION_BY_ID = "/admin/deduction/{id}";
export const ADMIN_DELETE_DEDUCTION_BY_ID = "/admin/deduction/{id}";

// Admin Manage Log Vehicle

export const ADMIN_GET_ALL_LOG_VEHICLE = "/admin/log_vehicle";
export const ADMIN_LOG_VEHICLE_EXCEL = "/admin/log_vehicle/download/excel";
export const ADMIN_GET_LOG_VEHICLE_BY_ID = "/admin/log_vehicle/{id}";

// Admin Manage Log Product

export const ADMIN_GET_ALL_LOG_PRODUCT = "/admin/log_product";
export const ADMIN_LOG_PRODUCT_EXCEL = "/admin/log_product/download/excel";
export const ADMIN_GET_LOG_PRODUCT_BY_ID = "/admin/log_product/{id}";

//Admin Manage Info
export const ADMIN_GET_ALL_INFO = "/admin/info";
export const ADMIN_CREATE_INFO = "/admin/info";
export const ADMIN_GET_INFO_BY_ID = "/admin/info/{id}";
export const ADMIN_UPDATE_INFO_BY_ID = "/admin/info/{id}";
export const ADMIN_DELETE_INFO_BY_ID = "/admin/info/{id}";

//Admin Manage Image
export const ADMIN_GET_IMAGE = "/admin/images/{nameFile}";
export const ADMIN_UPLOAD_IMAGE = "/admin/images";

//Admin Dashboard
export const ADMIN_DASHBOARD_ATTENDANCE = "/admin/dashboard/attendance";
export const ADMIN_DASHBOARD_ATTENDANCE_BY_PHOTO = "/admin/dashboard/attendance_by_photo";

//Admin Documents
export const ADMIN_GET_COMPANY_DOCUMENTS = "/admin/company_documents";

//Admin Collaboration History
export const ADMIN_GET_ALL_COLLABORATION_HISTORY = "/admin/collaboration_histories"

//Superadmin Account
export const SUPERADMIN_GET_TOKEN = "/superadmin/account/check_token";
export const SUPERADMIN_GET_CHANGE_COMPANY =
  "/superadmin/account/change_company/{companyId}";
export const SUPERADMIN_GET_COMBO_COMPANY = "/superadmin/account/combo_company";

//Superadmin Manage Company
export const SUPERADMIN_GET_COMBO_MENU_ADMIN =
  "/superadmin/company/combo_menu_admin";
export const SUPERADMIN_GET_COMPANY_LIST = "/superadmin/company";
export const SUPERADMIN_CREATE_COMPANY = "/superadmin/company";
export const SUPERADMIN_UPDATE_COMPANY = "/superadmin/company/{companyId}";
export const SUPERADMIN_GET_COMPANY_BY_ID = "/superadmin/company/{idCompany}";
export const SUPERADMIN_DELETE_COMPANY = "/superadmin/company/{idCompany}";
export const SUPERADMIN_GET_COMPANY_SETTING_BY_ID =
  "/superadmin/company/setting/{idCompany}";
export const SUPERADMIN_POST_COMPANY_SETTING_BY_ID =
  "/superadmin/company/setting";

//Superadmin Manage Notification
export const SUPERADMIN_GET_ALL_NOTIF = "/superadmin/notification";

// Superadmin Company Documents
export const SUPERADMIN_GET_COMPANY_DOCUMENTS = "/superadmin/company_documents";
export const SUPERADMIN_CREATE_COMPANY_DOCUMENTS = "/superadmin/company_documents";
export const SUPERADMIN_GET_BY_ID_COMPANY_DOCUMENTS = "/superadmin/company_documents/{documentId}";
export const SUPERADMIN_UPDATE_COMPANY_DOCUMENTS = "/superadmin/company_documents/{documentId}";
export const SUPERADMIN_DELETE_COMPANY_DOCUMENTS = "/superadmin/company_documents/{documentId}";

// Superadmin Collaboration History
export const SUPERADMIN_GET_ALL_COLLABORATION_HISTORY = "/superadmin/collaboration_histories"
export const SUPERADMIN_CREATE_COLLABORATION_HISTORY = "/superadmin/collaboration_histories"
export const SUPERADMIN_GET_BY_ID_COLLABORATION_HISTORY =  "/superadmin/collaboration_histories/{historyId}"
export const SUPERADMIN_UPDATE_COLLABORATION_HISTORY = "/superadmin/collaboration_histories/{historyId}"
export const SUPERADMIN_DELETE_COLLABORATION_HISTORY = "/superadmin/collaboration_histories/{historyId}"
export const SUPERADMIN_DOWNLOAD_COLLABORATION_HISTORY =  "/superadmin/collaboration_histories/excel/all"

//GUEST
export const GET_COMPANY_BY_INITIAL = "/guest/company/{initial}";
